import { render, staticRenderFns } from "./IndexSearchStaticFields.vue?vue&type=template&id=a8c50178&scoped=true&"
import script from "./IndexSearchStaticFields.vue?vue&type=script&lang=js&"
export * from "./IndexSearchStaticFields.vue?vue&type=script&lang=js&"
import style0 from "./IndexSearchStaticFields.vue?vue&type=style&index=0&id=a8c50178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c50178",
  null
  
)

export default component.exports